export default function customHatForm($scope, $http) {
    $scope.userHat = null
    $scope.fileInputLabel = 'REFERENCE'
    $scope.action = '';
    
    if(window.Laravel.app_env === 'local') {
        $scope.userName = 'Test';
        $scope.userPhone = '1234567890';
        $scope.userEmail = 'test@test.email'
        $scope.userEvent = 'test';
        $scope.userNeeds = 'test';
        $scope.response = '';
        $scope.sending = false;
    } else {
        $scope.userName = '';
        $scope.userPhone = '';
        $scope.userEmail = '';
        $scope.userEvent = '';
        $scope.userNeeds = '';
        $scope.response = '';
        $scope.sending = false;
    }
    $scope.gRecaptchaResponse = null;

    $scope.chooseHat = function (index) {
        this.userHat = index
    }

    $scope.submitForm = function () {
        if (this.userHat === null) {
            this.userHat = ''
        }

        if ($scope.customHatForm.$error.required) {
            let invalidField = null;

            $scope.customHatForm.$error.required.some(function (item) {
                invalidField = item.$$element
                return invalidField
            })

            $("html, body").animate({
                scrollTop: invalidField.offset().top - 180
            }, "slow");
        } else if (this.userHat === '') {
            $("html, body").animate({
                scrollTop: $('.hat-types').offset().top - 180
            }, "slow");
        }

        angular.forEach($scope.customHatForm.$error.required, function (field) {
            field.$setDirty();
        });

        if ($scope.customHatForm.$valid && this.userHat !== '') {
            $scope.action = window.Laravel.form_action;
            var formData = {
                name: this.userName,
                phone: this.userPhone,
                email: this.userEmail,
                event: this.userEvent,
                hat: this.userHat,
                needs: this.userNeeds,
                reference: this.userReference,
            };

            var formData = new FormData();
            formData.append("name", this.userName);
            formData.append("phone", this.userPhone);
            formData.append("email", this.userEmail);
            formData.append("event", this.userEvent);
            formData.append("hat", this.userHat);
            formData.append("needs", this.userNeeds);
            formData.append("userReferenceFileName", this.userReference);
            formData.append("_token", window.Laravel.csrfToken);
            formData.append("g-recaptcha-response", window.Laravel.recaptchaToken);

            angular.forEach($scope.uploadfiles, function (file) {
                formData.append('userReference', file);
            });
            $scope.sending = true;
            $scope.response = '';
            $http({
                method: "POST",
                url: $scope.action,
                data: formData,
                headers: {
                    "Content-Type": undefined
                    // "Content-Type": "multipart/form-data",
                    // "Content-type": "multipart/form-data; charset=utf-8; boundary=" + Math.random().toString().substr(2)
                }
            }).then(function (success) {
                $scope.sending = false;
                var data = success.data;
                $scope.response = data;
                dataLayer.push({
                    'event': 'Request_Completion'
                });
                console.log('Data: ', data);
                grecaptcha.reset();
                grecaptcha.execute();
            }, function (error) {
                $scope.sending = false;
                var data = error.data;
                $scope.response = data;
                console.log('Error: ', data);
                grecaptcha.reset();
                grecaptcha.execute();
            });
        }
    }

    $scope.resetForm = function () {
        $scope.sending = false;
        $scope.response = '';

        $scope.userHat = null
        $scope.fileInputLabel = 'REFERENCE'
        $scope.action = '';
        $scope.userName = '';
        $scope.userPhone = '';
        $scope.userEmail = '';
        $scope.userEvent = '';
        $scope.userNeeds = '';
        $scope.response = '';
        $scope.sending = false;
    }
}

customHatForm.$inject = ['$scope', '$http'];